var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 2,
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14 9a4 4 0 1 0 0-8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 18c1.45-3.33 4.11-5 8-5s6.55 1.67 8 5m.48-4.74q3.9.945 5.52 4.74"
  }))));
};
export default SvgUsers;